<template>
  <div id="createTeam" >
    <h4>您还尚未创建球队</h4>
    <router-link to="/" >创建球队</router-link>
  </div>
</template>
<script>
import Vue from 'vue'
import { Cell, CellGroup } from 'vant'
Vue.use(Cell, CellGroup)
export default {
  name: 'createTeam',
  data() {
    return {}
  },
  mounted () {},
  methods: {},
  computed: {}
}
</script>
<style>
#createTeam {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
}

#createTeam h4 {
  text-align: center;
  font-size: 18px;
}

#createTeam a {
  color: #199ed7;
  font-size: 16px;
  text-align: center;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/create-team-null.vue